import { render, staticRenderFns } from "./IconStarCashback.vue?vue&type=template&id=1b1f9d18&scoped=true&"
import script from "./IconStarCashback.vue?vue&type=script&lang=js&"
export * from "./IconStarCashback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1f9d18",
  null
  
)

export default component.exports